import { createAsyncThunk } from '@reduxjs/toolkit';
import { stopLoading } from '../slices/ui';
import { getCurrentUser } from './user';

export default createAsyncThunk('init', async (_, { dispatch }) => {
  if (localStorage.getItem('token')) {
    await dispatch(getCurrentUser()).unwrap();
  } else {
    dispatch(stopLoading());
  }
});
